import type { TFunction } from 'i18next';

/** Map Laravel English validation messages to the active locale. */
export function translateFieldError(message: string | undefined, fieldName: string | undefined, t: TFunction) {
    if (!message) return '';

    const field = fieldName
        ? String(t(`validation.fields.${fieldName}`, { defaultValue: fieldName.replaceAll('_', ' ') }))
        : '';

    if (/field is required/i.test(message)) {
        return String(t('validation.required', { field }));
    }

    if (/valid email/i.test(message)) {
        return String(t('validation.email', { field }));
    }

    if (/^The (selected )?.+ (must|may not|has to|is invalid)/i.test(message)) {
        return String(t('validation.invalid', { field }));
    }

    return message;
}
